import React from "react"
import Modal from "../../shared/Modal";
import CustomButton from "../../shared/CustomButton";

const ConfirmationModal = ({
  selected,
  saleAttribution,
  selectedUser,
  onCancelSaleAttribution,
  onUpdateSaleAttribution
}) => {

  const handleAcceptAction = e => {
    e.preventDefault()
    onUpdateSaleAttribution(saleAttribution.id,selectedUser.id)
  }

  return (
    <Modal show={selected} untoggle={onCancelSaleAttribution} extraSmall>
      <div className="gl2026-modal__header">
        <h4 className="gl2026-modal__title">Atenção</h4>
      </div>
      <div className="gl2026-modal__body">
        <div className="gl2026-modal__callout gl2026-modal__callout--warning">
          <p className="gl2026-modal__callout-text">Deseja realmente executar esta ação?</p>
          <p className="gl2026-modal__callout-text">Se aceitar, os pontos do contrato serão atribuídos ao utilizador indicado.</p>
        </div>
        <div className="gl2026-modal__callout gl2026-modal__callout--info">
          <p className="gl2026-modal__callout-text">A ação vai decorrer em segundo plano. Para confirmar a sua conclusão poderá verificar dentro de momentos a lista de “contratos atribuídos” ou atualizar a página.</p>
        </div>
      </div>
      <div className="gl2026-modal__footer">
        <CustomButton secondary type="button" onClick={onCancelSaleAttribution}>Cancelar</CustomButton>
        <CustomButton type="button" onClick={handleAcceptAction}>Aceitar</CustomButton>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
